module.exports = __webpack_public_path__ + "static/2015-header-b13d840f3166fd2cc2719a0dcd413aa9.jpg";